// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';
import { isClient } from '@tcp/core/src/utils/utils';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import LoginHeader from '../../LoginHeader';
import Notification from '../../../../../../common/molecules/Notification';
import withStyles from '../../../../../../common/hoc/withStyles';
import ImageComp from '../../../../../../common/atoms/Image';
import { getIconPath, getViewportInfo } from '../../../../../../../utils';
import styles, { StyledSubHeading } from '../styles/LoginTopSectionV2.styles';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
} from '../../../../../../../utils/labels/globalLogin.labels';

const showRedirectFromResetMessage = (lblResetPwdSuccessMsg, redirectFromReset) => {
  return (
    <>
      {redirectFromReset && (
        <div className="elem-pl-LRG elem-pr-LRG elem-pt-LRG">
          <Notification
            status="success"
            colSize={{ large: 12, medium: 8, small: 6 }}
            message={lblResetPwdSuccessMsg}
          />
        </div>
      )}
    </>
  );
};
const LoginTopSection = ({
  isCanada,
  variation,
  redirectFromReset,
  fullPage,
  isLoginWithOTPEnabled,
  labelGroup,
  loginFlowUXEnhancementEnabled,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const { extraConfig } = React.useContext(LabelsContext);
  const { isNewLoginScreen } = extraConfig || {};
  const { isMobile } = isClient() && getViewportInfo();

  const {
    lbl_login_checkout_modal_heading: lblLoginCheckoutModalHeading,
    lbl_login_heading_2: lblLoginHeading2,
  } = getDynamicLabelValues('dynamic.account_d');

  const {
    lbl_login_checkout: lblLoginCheckout,
    lbl_login_favorites_modal_heading: lblLoginFavoritesModalHeading,
    lbl_login_favorites_modal_heading_1: lblLoginFavModalHeading1,
    lbl_login_signIn_create_account: lblLoginSignInCreateAccount,
    lbl_reset_pass_succcessMsg: lblResetPwdSuccessMsg,
    lbl_login_subheading_v2: lblLoginSubHeadingV2,
  } = getLabelFromCopyOrFromTranslation(GLOBAL_LOGIN_LABELS, GlobalLoginLabels);

  const renderFavtandCheckout = () => {
    return (
      <React.Fragment>
        {variation === 'favorites' && (
          <>
            <BodyCopy component="div" textAlign="center">
              <ImageComp
                width={25}
                height={23}
                src={getIconPath('favourites')}
                className="elem-mb-LRG"
                data-locator="login-HEART"
              />
            </BodyCopy>
            <BodyCopy
              fontSize="fs16"
              fontWeight="black"
              fontFamily="secondary"
              textAlign="center"
              className="favt_modal_heading"
              color="gray.700"
            >
              {lblLoginFavoritesModalHeading}
            </BodyCopy>

            <BodyCopy component="span" fontSize="fs12" fontFamily="secondary" textAlign="center">
              {lblLoginFavModalHeading1}
            </BodyCopy>
            <BodyCopy component="div" textAlign="center" className="underline" />
          </>
        )}
      </React.Fragment>
    );
  };

  const headingLabel = fullPage ? lblLoginCheckoutModalHeading : lblLoginCheckout;
  return (
    <BodyCopy component="div" textAlign="center">
      <LoginHeader
        variation={variation}
        fullPage={fullPage}
        headingLabel={variation !== 'favorites' && headingLabel}
        subHeadingLabel={variation === 'checkout' && lblLoginSignInCreateAccount}
        isLoginWithOTPEnabled={isLoginWithOTPEnabled}
        labelGroup={labelGroup}
        loginFlowUXEnhancementEnabled={loginFlowUXEnhancementEnabled}
      />
      {showRedirectFromResetMessage(lblResetPwdSuccessMsg, redirectFromReset)}
      {!(variation === 'favorites' || variation === 'checkout') && (
        <>
          {!isCanada && (
            <StyledSubHeading
              textAlign="center"
              fontSize={isNewLoginScreen ? 'fs14' : 'fs13'}
              fontWeight={isNewLoginScreen ? 'semibold' : 'extrabold'}
              fontFamily="secondary"
              className="elem-mt-MED elem-mb-MED"
              isNewLoginScreen={isNewLoginScreen}
            >
              {isNewLoginScreen ? lblLoginSubHeadingV2 : lblLoginSignInCreateAccount}
            </StyledSubHeading>
          )}
          {isCanada && (
            <BodyCopy fontSize="fs12" fontFamily="secondary" textAlign="center">
              {lblLoginHeading2}
            </BodyCopy>
          )}

          {(!isMobile || isNewLoginScreen) && variation !== 'favorites' && (
            <BodyCopy component="div" textAlign="center" className="underline" />
          )}
        </>
      )}
      {renderFavtandCheckout()}
    </BodyCopy>
  );
};

LoginTopSection.propTypes = {
  isCanada: PropTypes.bool,
  variation: PropTypes.bool.isRequired,
  fullPage: PropTypes.bool,
  isLoginWithOTPEnabled: PropTypes.bool,
};

LoginTopSection.defaultProps = {
  isCanada: false,
  fullPage: false,
};

export default withStyles(LoginTopSection, styles);
export { LoginTopSection as LoginTopSectionVanilla };
